import { defineStore } from 'pinia'

export const useResultsStore = defineStore({
    id: 'citation-search-results',
    state: () => ({
        Overview: {} as server.CitationSearchResultOverview,
        Assessments: [] as Array<server.CitationSearchResultAssessment>,
        Attachments: [] as Array<server.CitationSearchResultAttachment>,
        checkoutTimer: null as Date | null,
    }),
    actions: {
        setResults(results: server.CitationSearchResult) {
            this.Overview = results.Overview;
            this.Assessments = results.Assessments.sort((a, b) => a.SortOrder - b.SortOrder);
            this.Attachments = results.Attachments;
        },

        clearResults() {
            this.Overview = {} as server.CitationSearchResultOverview;
            this.Assessments = [] as Array<server.CitationSearchResultAssessment>;
            this.Attachments = [] as Array<server.CitationSearchResultAttachment>;
            this.checkoutTimer = null;
        },

        setAmountUserWillPay(AmountToPay: number) {
            this.Overview.AmountToPay = AmountToPay;
        },

        setCheckoutTimer(SearchDate: Date) {
            this.checkoutTimer = SearchDate;
        }
    },
    persist: true,
})
